
  
  <template>
  <!-- class="dEquips" -->
  <div>
    <div class="wrapper grid-5">
      <template v-for="(_, i) in 8" :key="'row-' + i">
        <div
          v-for="(_, j) in 5"
          :key="'cell-' + i + j"
          class="equ_display_father"
        >
          <!-- <shanhe
            :item_data="role_shanhe"
            v-if="`${i}${j}` == '03' && !obj_is_null(role_shanhe)"
          /> -->

          <!-- <shili_item
            :item_data="role_shili_item"
            v-if="`${i}${j}` == '01' && !obj_is_null(role_shili_item)"
          /> -->

          <!-- <role_wing
            :role_data="role_data"
            v-else-if="`${i}${j}` == '21' && !obj_is_null(role_wings)"
          /> -->

          <mItemContainer :item_data="new_equipments[`${i}${j}`] || {}">
            <famous_wing
              :item_data="new_equipments[`${i}${j}`] || {}"
              v-if="`${i}${j}` == '11'"
            />

            <!-- <role_equ :item_data="new_equipments[`${i}${j}`] || {}" v-else /> -->
          </mItemContainer>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import famous_wing from './equipments_c/famous_wing.vue';
import role_equ from './equipments_c/role_equ.vue';
import role_wing from './equipments_c/role_wing.vue';
import shanhe from './equipments_c/shanhe.vue';
import shili_item from './equipments_c/shili_item.vue';

const props = defineProps({
  new_equipments: {
    type: Object,
    default: () => ({}),
  },
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const role_shanhe = computed(() => {
  return props.role_data?.role_shanhe || {};
});

const role_shili_item = computed(() => {
  console.log('role_shili_item', props.role_data.role_shili_item);
  return props.role_data.role_shili_item || {};
});

const role_wings = computed(() => {
  return props.role_data?.role_wings || {};
});

const obj_is_null = (obj) => {
  return Object.keys(obj).length == 0;
};
</script>

<style scoped lang="scss">
.dEquips {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.equ_display_father {
  flex: 1 1 calc(20% - 16px);
  min-width: 0;

  &:nth-child(5n + 1) {
    clear: both;
  }
}
</style>